import type { Optional } from '@festina-life/core'
import type { FC } from 'react'

import {
  isSubTemplatedField,
  isTemplateField,
  type SubTemplateValueSetupField,
} from '../../types/templateModel'
import type { ValidStackableRatios } from '../stackableTable/types'

export type SpecialCaseComponentProps = {
  data: SpecialCasedSubTemplatedValueSetup
}

type SpecialCaseRenderer = FC<SpecialCaseComponentProps>
export type SpecialCaseFieldComponentsConfiguration = {
  components: SpecialCaseRenderer[]
  sort?: (
    a: SpecialCasedSubTemplatedValueSetup,
    b: SpecialCasedSubTemplatedValueSetup,
  ) => number
  variableWidthTableColumns: Optional<
    { title: string; ratio: ValidStackableRatios }[]
  >
}

export type SpecialCasedSubTemplatedValueSetup = {
  subTemplateIdentifier: string
  field: SubTemplateValueSetupField
}

export const isSpecialCasedSubTemplatedValueSetup = (
  value: Optional<Record<string, unknown>>,
): value is SpecialCasedSubTemplatedValueSetup =>
  !!value &&
  'subTemplateIdentifier' in value &&
  'field' in value &&
  !!value['field'] &&
  isTemplateField(value['field']) &&
  isSubTemplatedField(value['field'])
